    <!-- Header -->
    <!-- <h2 class="text-primary poppins-medium px-8">Users List</h2> -->
<div class="card my-10 ">
    <app-title title="Users List"></app-title>      
<div class="card my-10">
    <p-table
      styleClass="list-table"  
      [value]="usersList"
      [paginator]="true"
      [rows]="perPage"
      [totalRecords]="totalRecords"
      [tableStyle]="{ 'min-width': '50rem' }"
      [rowsPerPageOptions]="[10,20,50]"
      (onLazyLoad)="onPageChange($event)"
      [lazy]="true"
      >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="sno">S.No</th>
          <th pSortableColumn="name">Name</th>
          <th pSortableColumn="email">Email</th>
          <th>Action</th>
        </tr>
      </ng-template>
  
      <!-- Body Template -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <td>{{ rowIndex + 1 }}</td>
          <td>{{ rowData.firstName ? (rowData.firstName | titlecase) : 'NA' }}</td>
          <td>{{ rowData.email }}</td>
          <td>
            <!-- Add actions here -->
            <button pButton type="button" icon="pi pi-eye" class="p-button-text" title="View" 
            [routerLink]="'/settings/users/view/'+ rowData.id" severity="secondary"></button>
            <button pButton type="button" icon="pi pi-pen-to-square" class="p-button-text" title="Edit"  [disabled]="rowData.email == 'rootadmin@cdss.com'" [routerLink]="'/settings/users/update/'+rowData.id" severity="secondary"></button>
            <button pButton type="button" icon="pi pi-trash" class="p-button-text" title="Delete" severity="secondary"  [disabled]="rowData.email == 'rootadmin@cdss.com'" (click)="confirmDelete(rowData.id, $event)" ></button>
          </td>
        </tr>
      </ng-template>
  
      <!-- Empty Data Template -->
      <ng-template pTemplate="empty">
        <tr>
          <td colspan="7" class="text-center">No Users Found</td>
        </tr>
      </ng-template>
    </p-table>

<p-confirmDialog header="Delete Confirmation" icon="pi pi-exclamation-triangle" [acceptLabel]="'Delete'" [rejectLabel]="'Cancel'"
  (onAccept)="deleteUser()">
</p-confirmDialog>
  </div>